import { DotLegalTableWithControls } from "@dotlegal/dotlegal-ui-components";
import React from "react";
import { IDotLegalTableWithControlsProps } from "@dotlegal/dotlegal-ui-components/dist/cjs/types/components/dotLegalTableWithControls/DotLegalTableWithControls";
import { useTranslation } from "../../../localization/useTranslation.ts";

function DotLegalTableWithControlsLocalized<T>(props: Omit<IDotLegalTableWithControlsProps<T>, "labelRowsPerPage" | "labelSearch" | "noOptionsLabel">) {
    const { translateString } = useTranslation();
    return (
        <DotLegalTableWithControls
            {...props}
            labelRowsPerPage={translateString("showEntites")}
            labelSearch={translateString("search")}
            noOptionsLabel={translateString("noOptions")}
            emptyText={props.emptyText ?? translateString("noData")}
            noSearchResultsText={translateString("noSearchResultsText")}
            paginationLabelOf={translateString("labelOf")}
            hideRowsPerPage={props.hideRowsPerPage === undefined ? true : props.hideRowsPerPage}
        />
    );
}

export default DotLegalTableWithControlsLocalized;
